import React, { useEffect, useRef, useState } from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';

const CustomYouTube = ({ opts = {}, ...restProps }: YouTubeProps) => {
  const [width, setWidth] = useState('');
  const wrapperWidthRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (wrapperWidthRef.current) {
      setWidth(`${wrapperWidthRef.current.clientWidth}px`);
    }
  }, [wrapperWidthRef]);
  return (
    <div className="w-full" ref={wrapperWidthRef}>
      <YouTube
        {...restProps}
        opts={{
          width,
          ...opts
        }}
      />
    </div>
  );
};

export default CustomYouTube;
